// JavaScript translations

class I18nHelper {
  constructor(element = null) {
    this.locale = document.body.dataset.i18nLocale || 'en';
    this.element = element;
    this.translations = null;
  }

  loadTranslations() {
    if (this.translations !== null) {
      return this.translations;
    }

    const sourceElement = this.element || document.querySelector('[data-translations]');

    if (sourceElement && sourceElement.dataset.translations) {
      try {
        this.translations = JSON.parse(sourceElement.dataset.translations);
        return this.translations;
      } catch (e) {
        console.warn('❌ Failed to parse translations from data attribute:', e);
      }
    } else {
      console.warn('❌ No element with data-translations found');
    }

    this.translations = {};
    return this.translations;
  }

  t(key, options = {}) {
    const translations = this.loadTranslations();
    const keys = key.split('.');
    let value = translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return k;
      }
    }

    if (typeof value === 'string') {
      // Simple interpolation for %{key} patterns
      return value.replace(/%\{(\w+)\}/g, (match, key) => {
        return options[key] || match;
      });
    }

    return value;
  }
}

window.I18n = new I18nHelper();

export default I18nHelper;
